export const SPRITES = {
  "oliver": {
    srcs: "assets/characters/oliver-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "hiddenPond": {
    srcs: "assets/locations/hiddenPond.png",
    width: 1216,
    height: 960
  },
  "ancientTree": {
    srcs: "assets/locations/ancientTree.png",
    width: 1216,
    height: 960
  },
  "windingPath": {
    srcs: "assets/locations/windingPath.png",
    width: 1216,
    height: 960
  },
  "forestClearing": {
    srcs: "assets/locations/forestClearing.png",
    width: 1216,
    height: 960
  }
};
